export const randomNumberGenerator = (max = 1, min = 0.1) => {
  const randomNumber = Math.random() * (max - min) + min;

  return randomNumber;
};
